import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
    async ({ params, endpoint, method, body }) => {
      const api = await getAxiosInstance();
      const getParams = (key) => {
        if (params?.[key]) {
          return `${key}=${params[key]}&`;
        } else {
          return "";
        }
      };

      try {
        const response = await api[method](
          `${endpoint}?${getParams("start_date")}${getParams(
            "end_date"
          )}${getParams("filter")}${getParams("sort_by")}sort_order=${params?.sort_order || "desc"
          }&length=${params?.length || "10"}&${getParams("search")}page=${params?.page || 1
          }`,
          body
        );

        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;

        return {
          data: err?.response?.data || err.message,
        };
      }
    };

export const bulkEnquiries = createApi({
  reducerPath: "bulkEnquiriesApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["bulkEnquiry"],
  endpoints: (builder) => ({

    getBulkEnquiryListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: '/v1/admin/contact/bulk-order-list'
      }),
      providesTags: ["bulkEnquiry"]
    }),

    updateTableFeildsData: builder.mutation({
      query(body) {
        return {
          endpoint: `/v1/admin/table-permission-create`,
          method: 'post',
          body,
        }
      },
      invalidatesTags: ["bulkEnquiry"],
    }),

    updateBulkEnquiryStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/contact/change-status`,
      }),

      invalidatesTags: ["bulkEnquiry"],
    }),
  }),
});

export const {


  useGetBulkEnquiryListDataQuery,
  useUpdateTableFeildsDataMutation,
  useUpdateBulkEnquiryStatusMutation
} = bulkEnquiries;
